<template>
	<div class="main situation">
		<div class="crumb" v-if="crumbList&&crumbList.length">
			<span v-for="(item,index) in crumbList" class="crumb_item" :key="index" @click="closeMask"><a href="javascript:;">{{item}}</a></span>
			<span class="order_list" style="display: flex;">
				<span class="crumb_item bg_eee" :class="{activeCrumb: item.recordNo == baseInfo.recordNo}" v-for="(item,index) in myAccidentList" :key="('accidentList_'+index)" @click="reStartMask(item.id)">
					{{item.recordNo}}
					<img src="../../assets/images/icon/home_tab_icon_close.png" alt="" class="close_img" @click.stop="doCancel(item.id,index)">
				</span>
			</span>
			<span class="jumpBtn">
				<div class="myJumpBtn" @click="setScrollTop(0)">基本信息</div>
				<div class="myJumpBtn" @click="setScrollTop(1)">人员信息</div>
				<div class="myJumpBtn" @click="setScrollTop(2)">话术模板</div>
				<div class="myJumpBtn" @click="setScrollTop(3)">上传文书</div>
				<div class="myJumpBtn" @click="setScrollTop(4)">返回凭证</div>
			</span>
		</div>
		<div style="height: 100%;">
			<div class="leftContent input_new_style" :class="[fullVideo ? 'fullVideoClass_left' : 'original_left']">
				<el-collapse v-model="activeNamesFirst">
					<el-collapse-item title="基本信息" name="1">
						<div class="tableContent">
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>违法处理地点</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="baseInfo.organizationId" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in daduiLists" :key="`${item.id}_xwdd`" :label="item.fullName" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>违法处理单位</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="baseInfo.handleOrganizationId" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in daduiLists" :key="`${item.id}_gzdw`" :label="item.fullName" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>经办人1</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="baseInfo.firstOperatorId" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in userLists" :key="`${item.id}_xwr1`" :label="item.realname" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>经办人2</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="baseInfo.secondOperatorId" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in userLists" :key="`${item.id}_xwr2`" :label="item.realname" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>违法处理时间</div>
										</div>
										<div class="right h32">
											<el-date-picker v-model="baseInfo.handleTime" type="datetime" :disabled="disabled_edit" placeholder="选择日期"></el-date-picker>
										</div>
									</div>
								</div>
                                <div class="row">
									<div class="column">
										<div class="left">
											<div>案件类型</div>
										</div>
										<div class="right h32">简易程序</div>
									</div>
								</div>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
				<el-collapse v-model="activeNamesSecond">
					<el-collapse-item title="人员信息" name="1">
						<div class="tableContent">
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>证件类型</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="userInfo.cardType" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in cardTypeLists" :key="`${item.id}_zjlx`" :label="item.label" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>人大代表/政协委员</div>
										</div>
										<div class="right h32">
											<el-select placeholder="请选择" v-model="userInfo.specialStatus" :disabled="disabled_edit" @change="$forceUpdate()">
												<el-option v-for="item in rdorzxLists" :key="`${item.id}_rddb/zxwy`" :label="item.label" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>身份证号</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfo.idCardNo" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>被询问人姓名</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfo.realName" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>性别</div>
										</div>
										<div class="right h32">
                                            <el-select placeholder="请选择" v-model="userInfo.sex" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="item in sexTypeLists" :key="`${item.id}_xb`" :label="item.label" :value="item.id"></el-option>
											</el-select>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>民族</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfo.nation" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
							</div>
							<div class="row-item h-49">
								<div class="row">
									<div class="column">
										<div class="left">
											<div>出生日期</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfo.birthday" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="column">
										<div class="left">
											<div>联系方式</div>
										</div>
										<div class="right h32">
											<el-input placeholder="请输入" v-model="userInfo.phone" :disabled="disabled_edit"></el-input>
										</div>
									</div>
								</div>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
				<el-collapse v-model="activeNamesThird">
					<el-collapse-item title="话术模板" name="1">
						<div class="tableContent">
							<div class="big_case" v-for="(item, index) in transcripts" :key="`${index}_xwbj`">
								<template v-if="item.operateType != 'REMOVE'">
									<ul class="ul_case">
										<li>
											<span>问：</span><el-input class="my_input" placeholder="请输入" type="textarea" :rows="3" v-model="item.question" :disabled="disabled_edit" @change="onChengeQ(index)"></el-input>
										</li>
										<li v-if="item.answerType == 'label'">
											<span>答：</span><el-input placeholder="请输入" type="textarea" :rows="1" v-model="item.answer" :disabled="disabled_edit" @change="onChengeQ(index)"></el-input>
										</li>
										<li v-else-if="item.answerType == 'select'">
											<span>答：</span>
											<el-select style="width: 100%" placeholder="请选择" v-model="item.answer" :disabled="disabled_edit" filterable @change="$forceUpdate()">
												<el-option v-for="an in JSON.parse(item.oriAnswer)" :key="`${an}_hbt`" :label="an" :value="an"></el-option>
											</el-select>
										</li>
									</ul>
									<ul class="ul_contor" v-if="!disabled_edit">
										<li>
											<i class="el-icon-refresh" @click="onCutQ(index)"></i>
										</li>
										<li>
											<i class="el-icon-plus" @click="onAddQ(index)"></i>
										</li>
										<li>
											<i class="el-icon-delete" @click="onDeletaQ(index, item)"></i>
										</li>
									</ul>
								</template>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
				<el-collapse v-model="activeNamesForth">
					<el-collapse-item title="上传文书" name="1">
						<template slot="title">
							<div style="width: 100%; display: flex; justify-content: space-between;">
								<span>
									上传文书
								</span>
								<span style="margin-right: 30px;" v-if="!disabled_edit">
									<el-button type="primary" size="mini" @click.stop="addScan(11)">添加警告文书</el-button>
									<el-button type="primary" size="mini" @click.stop="addScan(7)">添加违法文书</el-button>
								</span>
							</div>
						</template>
						<div class="wholeAcccindentClass">
							<div class="accidentImages">
								<!-- <div class="images">
									<div class="img-box" v-if="penaltiesImage">
										<img class="rotate_image" :src="getImageUrl(penaltiesImage)" />
										<div class="img-mask">
											<i class="el-icon-delete" v-if="!disabled_edit" @click="deleteImg(penaltiesImage)"></i>
											<i class="el-icon-zoom-in" @click="previewImg(penaltiesImage)"></i>
										</div>
									</div>
									<div class="img-box" v-else>
										<div class="img-mask-no">
											<div style="display: flex;" v-if="!disabled_edit">
												<i class="el-icon-folder-add" style="position: relative; margin-right: 20px; font-size: 30px; overflow: hidden;">
													<input class="upload-img" type="file" accept=".png,.jpg,.jpeg" @change="updateImg(7, $event)" />
												</i>
												<i class="el-icon-printer" style="font-size:30px;" @click="statrScan"></i>
											</div>
											<div>扫描处罚决定书</div>
										</div>
									</div>
								</div> -->
								<div class="images" v-for="(item, index) in clericalFiles" :key="index">
									<div class="img-box" v-if="item.penaltiesImage">
										<img class="rotate_image" :src="getImageUrl(item.penaltiesImage)" />
										<div class="img-mask">
											<i class="el-icon-delete" v-if="!disabled_edit" @click="deleteImg(index, item.ucode)"></i>
											<i class="el-icon-zoom-in" @click="previewImg(item.penaltiesImage)"></i>
										</div>
									</div>
									<div class="img-box" v-else>
										<div class="img-mask-no">
											<div style="display: flex;" v-if="!disabled_edit">
												<i class="el-icon-folder-add" style="position: relative; margin-right: 20px; font-size: 30px; overflow: hidden;">
													<input class="upload-img" type="file" accept=".png,.jpg,.jpeg" @change="updateImg(item.type, index, item, $event)" />
												</i>
												<i class="el-icon-printer" style="font-size:30px;" @click="statrScan(index, item)"></i>
											</div>
											<div>扫描文书</div>
										</div>
									</div>
								</div>
							</div>
							<div class="wholeAcccindentClass" style="margin-top: 25px; display: none;">
								<dwt :is_scan="is_scan" :roomId="roomId" :is_ucode="is_ucode" :is_fileType="is_fileType" @changeScanState="changeScanState"></dwt>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>
				<el-collapse v-model="activeNamesFifth">
					<el-collapse-item title="返回凭证" name="1">
						<div class="retrun_case">
							<!-- <img class="retrun_image" v-if="threeCardImage" :src="getImageUrl(threeCardImage) + '&time=' + new Date().getTime()" @click="previewImg(threeCardImage)">
							<img class="retrun_image" v-if="backIdCardImage" :src="getImageUrl(backIdCardImage) + '&time=' + new Date().getTime()" @click="previewImg(backIdCardImage)">
							<img class="retrun_image" v-if="backDriverImage" :src="getImageUrl(backDriverImage) + '&time=' + new Date().getTime()" @click="previewImg(backDriverImage)">
							<img class="retrun_image" v-if="halfBodyPhoto" :src="getImageUrl(halfBodyPhoto) + '&time=' + new Date().getTime()" @click="previewImg(halfBodyPhoto)"> -->
							<template v-for="(item, index) in evidences">
								<img class="retrun_image" :key="index" v-if="item.indexOf('.mp4') == -1" :src="getImageUrl(item) + '&time=' + new Date().getTime()" @click="previewImg(item)">
								<img class="retrun_image" :key="index" v-else src="../../assets/images/pics/player.png" @click="previewImg(item)" />
							</template>
							<template v-if="certificateFileUrl">
								<img class="retrun_image rotate_image" v-for="(item, index) in certificateFileUrl" :key="index" :src="getImageUrl(item.certificateImage) + '&time=' + new Date().getTime()" @click="previewImg(item.certificateImage)">
							</template>
							<template v-else-if="signFileImage">
								<img class="retrun_image rotate_image" v-for="(item, index) in signFileImage" :key="index" :src="getImageUrl(item.certificateImage) + '&time=' + new Date().getTime()" @click="previewImg(item.certificateImage)">
							</template>
						</div>
					</el-collapse-item>
				</el-collapse>
				<div style="width: 100%; height: 66px;"></div>
				<div style="display:none;">
					<template v-if="certificateFileUrl">
						<div ref="print">
							<img class="retrun_image" style="width:100%; height:auto;" v-for="(item, index) in certificateFileUrl" :key="index" :src="getImageUrl(item.certificateImage) + '&time=' + new Date().getTime()">
						</div>
					</template>
					<!-- <img class="retrun_image" style="width:100%; height:auto;" ref="print" v-else-if="signFileImage" :src="getImageUrl(signFileImage) + '&time=' + new Date().getTime()"> -->
				</div>
			</div>

			<div class="rightContent" :class="{ fullVideoClass_right: fullVideo }">
				<div class="left no_video_text" v-if="trtcStatus">
					<span v-if="!disabled_edit">
						<el-button style="width:200px;" type="success" v-if="remoteStatus == 'success' && !hasLocal">用户在线</el-button>
						<el-button style="width:200px;" type="danger" v-if="remoteStatus == 'danger' && !list.length">用户离线</el-button>
					</span>
				</div>
				<!--左边成员列表名单-->
				<div class="left" v-else>
					<div v-if="videoBtnShow" class="videoBtnZone">
						<span id="myBtnCase2" v-if="!disabled_edit">
							<el-button type="success" v-if="remoteStatus == 'success' && !hasLocal" v-preventReClick="5000" @click="getRoom">视频呼叫</el-button>
							<el-button type="danger" v-if="remoteStatus == 'danger' && !list.length" v-preventReClick="5000" @click="notInRoom">视频呼叫</el-button>
						</span>
					</div>
					<span v-show="videoState == 0" class="display-flex-between—new" style="margin-top: 478px;">
						<div id="warp myLocal" class="userlist local" :class="[myTempIndex === null ? myMainVideo : '']" v-if="localStream" @click="switchLocalMain1($event)">
							<div id='local_stream'>
								<div class="role1" v-if="list.length" @click.stop="muteLocalAudio">
									<img class="policeMuteClass" :src="isAudio ? require('../../assets/images/pics/icon_microphone2_sel.png') : require('../../assets/images/pics/icon_microphone2_nor.png')">
									<span>交警</span>
								</div>
								<!-- <div class="role2" v-if="list.length">
                                    <img src="../../assets/images/pics/icon_video_open.png" class="myIcon" v-if="list.length > 0 && !isShow" @click.stop="onChangeView" />
                                    <img src="../../assets/images/pics/icon_video_close.png" class="myIcon" v-if="list.length > 0 && isShow" @click.stop="onChangeView" />
                                </div> -->
							</div>
							<div id='mask' class="maskable" v-show="!isVedio"></div>
						</div>
						<div id="warp" class="userlist bg-white remote police" v-if="list.length && showPolice">
							交警
						</div>
						<div class="userlist remoteClass remote user" v-for="(item,index) in list" :key="item.id" :class="[myTempIndex === index ? myMainVideo : '']">
							<div :id="item.id" class="distant-stream" v-html="item.remoteStream" v-if="item.remoteStream"></div>
						</div>
					</span>
					<!--远端流-->
					<div class="display-flex margin-top-15">
						<!-- <div class="myBtn" v-if="!videoBtnShow" @click="showAmbuVisible">
                            <img src="../../assets/images/pics/icon_120_sel.png" alt="">
                            <div class="">
                                接入120
                            </div>
                        </div>
                        <div class="myBtn" v-if="!videoBtnShow" @click="showDialogVisible">
                            <img src="../../assets/images/pics/icon_add.png" alt="">
                            <div class="">
                                添加通话
                            </div>
                        </div> -->
						<div class="myBtn" v-if="!videoBtnShow" @click="leaveRoom">
							<img src="../../assets/images/pics/icon_hang_up.png" alt="">
							<div class="">
								挂断
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="bottomBtns">
			<el-button type="primary" v-if="!disabled_edit" @click="sendSignBook">推送文书</el-button>
			<el-button type="primary" v-if="!disabled_edit" @click="seeSignBook">查看文书</el-button>
			<el-button type="primary" v-if="!disabled_edit" @click="printSignBook">打印文书</el-button>
			<el-button type="danger" v-if="!disabled_edit" @click="stopHandle">处置终止</el-button>
			<el-button type="success" v-if="!disabled_edit" @click="onFinish">全流程完成</el-button>
			<el-button plain @click="closeMask">返回</el-button>
			<el-button style="margin-left:100px" type="primary" plain v-if="!disabled_edit" @click="onSendImages">重发三证短信</el-button>
			<el-button type="primary" plain v-if="!disabled_edit" @click="onSendMessage">重发用户短信</el-button>
			<el-button type="danger" v-if="!disabled_edit" @click="onFirstWS">首违文书推送</el-button>
			<!-- <div class="hang_up_btn" v-if="!videoBtnShow" @click="leaveRoom">
				<img src="../../assets/images/pics/icon_hang_up.png" alt="">
			</div> -->
		</div>

		<el-dialog width="80%" title="话术模板问题" center :visible.sync="dialog_state" :close-on-click-modal="false" :append-to-body="true">
			<div class="big_case" v-for="(item, index) in questions" :key="`${index}_xwbj`">
				<ul class="ul_case">
					<li>
						<span>问：</span><el-input disabled placeholder="请输入" type="textarea" :rows="1" v-model="item.question"></el-input>
					</li>
					<li>
						<span>答：</span><el-input disabled placeholder="请输入" type="textarea" :rows="1" v-model="item.answer"></el-input>
					</li>
					<!-- <li v-else-if="item.answerType == 'select'">
                        <span>答：</span>
                        <el-select style="width: 100%" disabled placeholder="请选择" v-model="item.answer" filterable @change="$forceUpdate()">
                            <el-option v-for="an in JSON.parse(item.oriAnswer)" :key="`${an}_hbt`" :label="an" :value="an"></el-option>
                        </el-select>
                    </li> -->
				</ul>
				<ul class="ul_contor">
					<li class="ul_li_btn" @click="onSelectQ(index, item)">选择</li>
				</ul>
			</div>
		</el-dialog>

		<el-dialog width="50%" title="首违文书" center :visible.sync="firstVisible" :close-on-click-modal="false" :close-on-press-escape="false" :modal-append-to-body="false" :before-close="onBeforeClose" destroy-on-close>
			<FirstWs v-if="firstVisible" :key="componentKey" :componentId="roomId" @onClose="onBeforeClose" />
		</el-dialog>
	</div>
</template>

<script>
	import LibGenerateTestUserSig from "../../../static/js/lib-generate-test-usersig.min.js";
	import $ from "../../../static/js/jquery-3.2.1.min.js";
	import TRTC from "trtc-js-sdk";
	import config from "@/common/env.js";
	import { mapState } from "vuex";
	import dwt from "./components/dwt"
	import FirstWs from "./components/firstWs.vue"

	export default {
		props: ["roomId"],
		name: "videoEasy",
		components: {
			dwt,
			FirstWs,
		},
		data() {
			return {
				// ---------- new data ----------
				activeNamesFirst: ["1"],
				activeNamesSecond: ["1"],
				activeNamesThird: ["1"],
				activeNamesForth: ["1"],
				activeNamesFifth: ["1"],
				daduiLists: [],
				userLists: [],
				wenhuaLists: [],
				cardTypeLists: [
                    {id: 1, label: "身份证"},
					// {id: 2, label: "驾驶证"},
				],
				rdorzxLists: [
                    {id: "1", label: "是"},
					{id: "0", label: "否"},
				],
                sexTypeLists: [
                    {id: 1, label: "男"},
					{id: 0, label: "女"},
				],
				baseInfo: {},
				userInfo: {},
				questions: [],
				transcripts: [],
				evidences: [],
				// transcriptImage: null,
				penaltiesImage: null,
				// simplePenaltiesImage: null,
				// certificateImage: null,
				threeCardImage: null,
				backIdCardImage: null,
				backDriverImage: null,
				halfBodyPhoto: null,
				signFileImage: null,
				dialog_state: false,
				s_index: null,
				s_type: null,
				certificateFileUrl: null,
				is_scan: false,
				key_scan: 1,

				disabled_edit: false,

				// -------------------- old data --------------------

				// ***** 音视频data start *****
				myTempIndex: 0,
				remoteUserStatus: false,
				muteMeObj: {},
				margin0: "margin0",
				tempKey: {},
				showPolice: true,
				hasLocal: false,
				fullVideo: false,
				list: [], // 远端流列表
				client: "", // 客户端服务
				remoteStream: "", // 远方播放流
				localStream: "", // 本地流,
				isVedio: true, // 当前是否打开摄像头
				isAudio: true, // 当前是否打开麦克风
				members_: new Map(), // 成员
				isHave: false, //当前列表是否有该成员
				stream: null,
				newStream: null,
				videoBtnShow: true,

				myMainVideo: "myMainVideo",
				userId: "",

				// ***** 音视频data end *****
				trtcStatus: false,
				noSave: false,
				id: null,
				usePart: null,
				nowId: "",
				userItemInterval: null,
				videoState: 0, //-1代表默认;0代表微信;1代表支付宝
				isShowView: false,
				disabled_btn: false,
				clericalFiles: [
					// {
					// 	penaltiesImage: null,
					// 	certificateImage: null,
					// 	ucode: this.get_guid()
					// }
				],
				is_ucode: null,
				is_index: null,
				is_fileType: null,

				componentKey: null,
				firstVisible: false,

			}
		},
		watch: {
			myTempIndex(newVal, oldVal) {
				console.log(newVal)
				if (newVal == 0 || newVal) {
					if (this.list.length == 1) {
						let local = document.getElementById('local_stream');
						local.classList.add('margin0');
					} else {
						$("#local_stream").removeClass('margin0');
					}
				}
			},

		},
		computed: {
			...mapState(['command', 'myAccidentList']),

			crumbList() {
				return this.$route.meta.crumbList;
			},
			isShow() {
				let isShowView = this.isShowView || sessionStorage.getItem('isShowView');
				if (isShowView == 'true' || isShowView == true) {
					return true;
				} else if (isShowView == 'false' || isShowView == false) {
					return false;
				} else {
					return false;
				}
			},
			remoteStatus() {
				return this.remoteUserStatus ? "success" : "danger";
			},

		},
		beforeMount() {
			var beginTime = 0; //执行onbeforeunload的开始时间
			var differTime = 0; //时间差
			let that = this;
			window.onunload = function() {
				differTime = new Date().getTime() - beginTime;
				if (differTime <= 5) {
					console.log("浏览器关闭")
					that.saveTemp();
				} else {
					console.log("浏览器刷新")
					// that.saveTemp();
				}
			}
			window.onbeforeunload = function() {
				beginTime = new Date().getTime();
			}

		},
		created() {
			// this.getDaduiLists();
			this.getUserLists();

		},
		mounted() {
			window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))

			let that = this;
			window.muteMyVideo = this.muteMyVideo;
			window.muteMyAudio = this.muteMyAudio;
			window.stopMyVideo = this.stopMyVideo
			window.snapMyVideo = this.snapMyVideo;
			window.kickPerson = this.kickPerson;
			window.goTop = this.goTop;

			this.myLoopMethod();
			clearInterval(this.userItemInterval);
			this.userItemInterval = setInterval(() => {
				that.myLoopMethod();
			}, 4000)

			this.getNewDetail();
		},
		beforeDestroy() {
			console.log("卸载")
			if (!this.noSave) {
				this.saveTemp();
			}
			window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))

			this.leaveRoom();
			clearInterval(this.userItemInterval);
		},
		methods: {
			// ---------- new methods ----------
			// 获取大队列表
			getDaduiLists() {
				this.$axios.get(`/admin/organization/childrenList/parent-${this.baseInfo.organizationParentId}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if (code == 0) {
						this.daduiLists = data;
					}
				})
			},
			// 询问人 and 记录人
			getUserLists() {
				let id = JSON.parse(localStorage.getItem("userinfos")).organizationId || null;
				this.$axios.get(`/admin/organization/users/${id}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if (code == 0) {
						this.userLists = data;
					}
				})
			},

			// 详情
			getNewDetail() {
				this.$axios.get(`/admin/appointment/detail/${this.roomId}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if (code == 0) {
						this.userId = data.baseInfo.videoUserId;
						this.trtcStatus = data.trtcStatus == 1 ? false : true;

						if(data.baseInfo.status >= 3 && data.baseInfo.status != 7) {
							this.disabled_edit = true;
							clearInterval(this.userItemInterval);
						} else {
							this.disabled_edit = false;
						}
						this.baseInfo = Object.assign({}, this.baseInfo, data.baseInfo);
						this.getDaduiLists();
						this.userInfo = Object.assign({}, this.baseInfo, data.userInfo[0], 
							{
								specialStatus: data.userInfo[0].specialStatus == 1 ? "1" : "0",
								birthday: data.userInfo[0].birthday ? data.userInfo[0].birthday.replace(/\//g, '-') : ""
							}
						);
						this.questions = Object.assign([], this.questions, data.questions);
						this.transcripts = Object.assign([], this.transcripts, data.transcripts);
						this.evidences = Object.assign([], this.evidences, data.evidences);
						this.penaltiesImage = data.penaltiesImage;
						this.threeCardImage = data.threeCardImage;
						this.backIdCardImage = data.backIdCardImage;
						this.backDriverImage = data.backDriverImage;
						this.halfBodyPhoto = data.halfBodyPhoto;
						// this.signFileImage = data.signFileImage;
						if(data.baseInfo.status >= 3) {
							this.signFileImage = data.clericalFiles;
						}
						if(data.clericalFiles.length > 0) {
							this.clericalFiles = data.clericalFiles;
						}
					}
				})
			},
			// 推送文书
			sendSignBook() {
				this.$axios.get(`/admin/appointment/push/sign/${this.roomId}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data, msg } = datas;
					if (code == 0) {
						this.$message.success("推送文书成功");
						this.getNewDetail();
					} else {
						this.$message.error(msg);
					}
				})
			},

			// 查看文书
			seeSignBook() {
				if(this.baseInfo.status == 3) {
					this.previewImg(this.signFileImage, "type3");
				}
				if(this.certificateFileUrl == null) return this.$message.error("文书未签字！");
				this.previewImg(this.certificateFileUrl[0].certificateImage, "type");
			},

			// 打印文书
			printSignBook() {
				if(this.certificateFileUrl == null) return this.$message.error("文书未签字！");
				let options = { style: "no" }
				this.$print(this.$refs.print, options);
			},

			// 处置终止
			stopHandle() {
				this.$confirm('确定处置终止, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$axios.get(`/admin/appointment/stop/${this.roomId}`).then(res => {
						let datas = this.AppUtils.checkResponse(res);
						let { code, data, msg } = datas;
						if (code == 0) {
							this.noSave = true;
							this.$message.success("处置终止成功");
							this.getStartMethods();
						} else {
							this.$message.error(msg);
						}
					})
				}).catch(() => {

				})
			},

			// 全流程完成
			onFinish() {
				this.$confirm('确定全流程处置完成？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'success'
				}).then(() => {
					this.$axios.get(`/admin/appointment/finish/${this.roomId}`).then(res => {
						let datas = this.AppUtils.checkResponse(res);
						let { code, data, msg } = datas;
						if (code == 0) {
							this.noSave = true;
							this.$message.success("全流程完成成功");
							this.getStartMethods();
						} else {
							this.$message.error(msg);
						}
					})
				}).catch(() => {

				})
			},

			// 重发三证短信
			onSendImages() {
				this.$axios.get(`/admin/appointment/push/threeCard/${this.roomId}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data, msg } = datas;
					if (code == 0) {
						this.$message.success("发送成功");
					} else {
						this.$message.error(msg);
					}
				})
			},
			// 重发用户短信
			onSendMessage() {
				this.$axios.get(`/admin/appointment/reinvite/${this.roomId}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data, msg } = datas;
					if (code == 0) {
						this.$message.success("发送成功");
					} else {
						this.$message.error(msg);
					}
				})
			},

			// 首违文书推送
			onFirstWS() {
				this.componentKey = Date.now();
				this.firstVisible = true;
			},
			onBeforeClose(val) {
				this.firstVisible = false;
				if(val && val.penaltiesImage) {
					this.clericalFiles = [val];
				}
			},

			// 笔录相关操作
			onCutQ(index) {
				this.dialog_state = true;
				this.s_index = index;
				this.s_type = 1;
			},
			onAddQ(index) {
				this.dialog_state = true;
				this.s_index = index;
				this.s_type = 2;
			},
			onDeletaQ(index, item) {
				console.log(index)
				console.log(item)
				console.log(this.transcripts)
				let data = this.transcripts;
				data[index].operateType = "REMOVE";
				this.transcripts = data;
				this.$forceUpdate();
			},
			onSelectQ(index, item) {
				console.log(index)
				console.log(item)
				console.log(this.s_index)
				console.log(this.s_type)
				let json = {
					answer: null, //question.answer
					answerType: null,
					operateType: "ADD",
					oriAnswer: null,
					oriQuestion: null,
					question: null, //question.question
					questionId: null,
					questionItemId: null, //questions.id
					recordId: this.roomId,
					answerType: "label",
				}
				if (this.s_type == 1) {
					let data = this.transcripts;
					data[this.s_index].operateType = "UPDATE";
					data[this.s_index].question = item.question;
					data[this.s_index].answer = item.answer;
					data[this.s_index].questionItemId = item.id;
					this.transcripts = data;
					this.$forceUpdate();
				} else if (this.s_type == 2) {
					let data = this.transcripts;
					json.answer = item.answer;
					json.question = item.question;
					json.questionItemId = item.id;
					data.splice(this.s_index + 1, 0, json);
					this.transcripts = data;
					this.$forceUpdate();
				}
				this.dialog_state = false;
			},
			onChengeQ(index) {
				console.log(index)
				let data = this.transcripts;
				data[index].operateType = data[index].questionId == null ? "ADD" : "UPDATE";
				this.transcripts = data;
				this.$forceUpdate();
			},

			// 扫描仪
			statrScan(index, item) {
				this.is_ucode = item.ucode;
				this.is_fileType = item.type;
				this.is_index = index;
				this.is_scan = true;
			},
			changeScanState(val) {
				console.log("scan=>", val)
				if (val.state) {
					this.clericalFiles[this.is_index].penaltiesImage = val.url;
					this.$forceUpdate();
					this.is_scan = false;
					// this.penaltiesImage = val.url;
					// this.saveTemp("no");
				} else {
					this.key_scan = this.key_scan++;
					this.is_scan = false;
				}
			},

			addScan(n) {
				let json = {
					type: n,
					penaltiesImage: null,
					certificateImage: null,
					ucode: this.get_guid()
				}
				this.clericalFiles.push(json);
			},

			get_guid() {
				function S4() {
					return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
				}
				return (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4());
			},

			// 图片上传
			updateImg(usePart, index, item, e) {
				let file = e.target.files[0];
				console.log(usePart)
				console.log(file)
				console.log(index)
				console.log(item)
				this.getUploadInfo(file, usePart, index, item);
			},
			getUploadInfo(file, usePart, index, item) {
				let formData = new FormData();
				formData.append("file", file);
				formData.append("fileType", usePart);
				formData.append("uCode", item.ucode);
				formData.append("recordId", this.roomId);

				// this.$axios.post(`/admin/appointment/upload/file`, formData).then(res => {
				this.$axios.post(`/admin/appointment/upload/penalties`, formData).then(res => {
					console.log(res)
					let { code, data, msg } = res.data;
					if (code == 0) {
						if (usePart == 5) {

						} else if (usePart == 6) {

						} else if (usePart == 7) {
							this.clericalFiles[index].penaltiesImage = data.url;
							this.$forceUpdate();

							// this.penaltiesImage = data.url;
							// this.saveTemp("no");
						} else if (usePart == 11) {
							this.clericalFiles[index].penaltiesImage = data.url;
							this.$forceUpdate();
						}
					} else {
						this.$message.error(msg);
					}
				})

			},
			getImageUrl(url, type) {
				let str = type ? "/file/server/file" : "/file/server/decrypt/file";
				return `${config.baseUrl}${str}?path=${encodeURI(url)}`;
			},
			previewImg(url, type) {
				// let data = [this.threeCardImage, this.backIdCardImage, this.backDriverImage];
				// if(this.halfBodyPhoto) data.push(this.halfBodyPhoto);
				let data = [];
				let evidences = JSON.parse(JSON.stringify(this.evidences));
				evidences.forEach(item => {
					if(item.indexOf('.mp4') == -1) data.push(item);
				})
				if (this.signFileImage != null) {
					data.push(this.signFileImage);
				}
				if (this.clericalFiles.length > 0) {
					this.clericalFiles.forEach(item => {
						data.push(item.penaltiesImage)
					})
				}
				if (this.certificateFileUrl != null && this.certificateFileUrl.length > 0) {
					this.certificateFileUrl.forEach(item => {
						data.push(item.certificateImage)
					})
				}
				if (type == "type") {
					data = [];
					// data = [this.certificateFileUrl]
					this.certificateFileUrl.forEach(item => {
						data.push(item.certificateImage)
					})
				} else if(type == "type3") {
					data = [];
					data = [this.signFileImage]
				}
				data = Array.from(new Set(data));
				let index = data.findIndex(item => item == url);
				let that = this;
				if (this.$store.state.previewImgUrl) {
					this.$store.commit("SHOW_PREVIEW_IMG", '')
				}
				setTimeout(() => {
					if (index > -1) {
						localStorage.setItem('myIndex', index);
						localStorage.setItem('myPics', JSON.stringify(data));
					} else {
						data.push(url);
						localStorage.setItem('myIndex', data.length - 1);
						localStorage.setItem('myPics', JSON.stringify(data));
					}
					localStorage.setItem('newDe', '');
					that.$store.commit("SHOW_PREVIEW_IMG", url);
				}, 500)
			},


			// ---------- old methods ----------

			// 案情暂存
			saveTemp(arg) {
				console.log("baseInfo", this.baseInfo)
				console.log("userInfo", this.userInfo)
				console.log("questions", this.questions)
				console.log("transcripts", this.transcripts)

				if(this.disabled_edit) return;

				this.$axios.post(`/admin/appointment/save`, {
					baseInfo: this.baseInfo,
					userInfo: [this.userInfo],
					transcripts: this.transcripts,
					// transcriptImage: this.transcriptImage,
					// penaltiesImage: this.penaltiesImage,
					// simplePenaltiesImage: this.simplePenaltiesImage,
					// certificateImage: this.certificateImage
				}).then(res => {
					console.log(res)
					let { code, data, msg } = res.data;
					if (code == 0) {
						if (arg == "no") {

						} else {
							this.$message.success("保存成功");
						}
					} else {
						this.$message.error(msg);
					}
				})
			},

			myLoopMethod() {
				let accidentId = this.roomId;
				this.$axios.get(`/admin/appointment/record/${accidentId}/status`).then((res) => {
					let data = this.AppUtils.checkResponse(res);
					let status = data.data;
					if (res.data.code == 0) {
						this.remoteUserStatus = status.userOnline;
						// if(status.userOnline && status.certificateFileUrl) {
						// this.certificateFileUrl = status.certificateFileUrl;
						this.certificateFileUrl = JSON.parse(status.certificateFileUrl);
						// }
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			doCancel(id, inde) {
				let accidentList = this.$store.state.myAccidentList;
				let index = inde;
				if (index > -1) {
					if (index == 0 && accidentList.length == 1) {
						this.closeMask();
						this.$store.commit('MyAccidentList', []);
						return false;
					}
					accidentList.splice(index, 1);
					this.$store.commit('MyAccidentList', accidentList);
					let ind = index - 1;
					if (ind < 0) {
						ind = 0;
					}
					this.reStartMask(accidentList[ind].id);
				}

			},
			reStartMask(id) {
				this.$emit('reStartMask', id)
			},

			setScrollTop(type, index) {
				let topValue;
				let topArray = [];
				if (type == 0) {
					topValue = 0;
				} else if (type == 1) {
					topValue = document.getElementsByClassName('el-collapse')[0].clientHeight;
				} else if (type == 2) {
					topValue = document.getElementsByClassName('el-collapse')[0].clientHeight;
					topValue += document.getElementsByClassName('el-collapse')[1].clientHeight;
				} else if (type == 3) {
					let times = document.getElementsByClassName('el-collapse').length - 1;
					for (var i = 0; i < times; i++) {
						topArray.push(document.getElementsByClassName('el-collapse')[i].clientHeight);
					}
					topValue = topArray.reduce((pre, val) => {
						return pre += val;
					}, 0);
				} else if (type == 4) {
					let times = document.getElementsByClassName('el-collapse').length - 1;
					for (var i = 0; i < times; i++) {
						topArray.push(document.getElementsByClassName('el-collapse')[i].clientHeight);
					}
					topValue = topArray.reduce((pre, val) => {
						return pre += val;
					}, 0);
				}
				$('.leftContent').animate({
					scrollTop: topValue
				}, 500);
			},

			beforeunloadHandler(e) { //根据事件进行操作进行操作
				console.log(e)
				console.log('浏览器刷新')
				this.saveTemp();
			},

			switchLocalMain1(e) {
				this.myTempIndex = null;
			},

			goTop(userId, id) {
				let ind;
				let members = this.list;
				members.forEach((item, index) => {
					if (item.userId == userId) {
						ind = index;
					}
				})
				this.myTempIndex = ind
			},

			onChangeView() {
				let notDisplay = !this.isShowView;
				this.$axios.post(`/admin/accident/display/video`, {
					notDisplay: notDisplay
				}).then(res => {
					let { code, data } = res.data;
					if (code === 0) {
						let title = notDisplay ? "车主端已关闭警端视频" : "车主端已打开警端视频";
						this.$message.success(title);
						this.isShowView = !this.isShowView;
						sessionStorage.setItem('isShowView', this.isShowView)
					}
				})
			},

			getRoom() {
				var accidenId = this.roomId;
				this.$axios.post(`/admin/appointment/${accidenId}/video/room/create`).then((res) => {
					let data = res.data;
					if (data.code === 0) {
						this.myTempIndex = 0;
						this.nowId = data.data;
						this.startJoinRoom();
						this.isAudio = true;
					} else {
						this.$message.error(data.msg);
					}
				})
			},

			kickPerson(userId) {
				let ind;
				let members = this.members_;
				let values = members.values();
				values = Array.from(values);
				let keys = members.keys();
				keys = Array.from(keys);
				values.forEach((item, index) => {
					if (item.getUserId() == userId) {
						ind = index;
					}
				})
				let that = this;
				let accidentId = this.roomId;
				let roomId = this.nowId;
				this.$axios.post(`/admin/accident/${accidentId}/video/room/${roomId}/remove/${userId} `).then(res => {
					let data = res.data;
					if (data.code === 0) {} else {
						this.$message.error(data.msg)
					}
				})
			},

			getStartMethods() {
				if (this.newStream) {
					this.leaveRoom();
				}
				clearInterval(this.userItemInterval);
				this.$emit("closeMask");
				this.$emit("startMethod");
			},

			async snapRemote(key, usePart, index) {
				if (!this.remoteUserStatus) {
					this.$message.error("报警人已退出");
					return false;
				}
				if (!this.newStream) {
					this.$message.error("截图失败,请检查视频是否接通!");
					return false;
				}
				this.tempKey = {
					key,
					usePart,
					index,
				}
			},

			deleteImg(index, ucode) {
				this.$axios.get(`/admin/appointment/remove/penalties?uCode=${ucode}`).then(res => {
					let datas = this.AppUtils.checkResponse(res);
					let { code, data } = datas;
					if (code == 0) {
						this.clericalFiles.splice(index, 1);
						this.$forceUpdate();
					}
				})
				// this.penaltiesImage = null;
				this.is_scan = false;
			},

			closeMask() {
				this.$emit("closeMask");
				this.leaveRoom();
				this.getStartMethods();
			},

			// *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-* 音视频相关操作 start *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*

			notInRoom() {
				this.$message.error("预约人未在等待状态");
			},
			startJoinRoom() {
				if (!this.remoteUserStatus) {
					// return this.$message.error("报警人未在等待状态");
				}
				this.createClient(this.userId);
			},

			close() {
				this.isVedio = true;
				this.isAudio = true;
				this.isShow = false;
				this.$emit("close");
			},

			// 创建链接
			createClient(userId) {
				// 获取签名
				const config = this.genTestUserSig(userId);
				const sdkAppId = config.sdkAppId;
				const userSig = config.userSig;
				this.client = TRTC.createClient({
					mode: "rtc",
					sdkAppId,
					userId,
					userSig,
					useStringRoomId: true,//指定房间号为字符串；有roomType打开，没有roomType去掉
				});
				// 初始化后才能加入房间
				this.joinRoom();
			},
			// 加入房间
			async joinRoom() {
				console.log("this.nowId", this.nowId);
				await this.client
					.join({
						// roomId: Number(this.nowId),//没有roomType
						roomId: config.roomType + Number(this.nowId),//有roomType
					})
					.then(() => {
						// 创建本地流
						this.createStream();
						// 播放远端流
						this.playStream();
					})
					.catch((error) => {
						console.error("进房失败 " + error);
					})

				// 注册远程监听，要放在加入房间前--这里用了发布订阅模式
				this.subscribeStream();
			},
			// 创建本地音视频流
			createStream() {
				var _this = this;
				this.localStream = TRTC.createStream({
					userId: this.userId,
					audio: true,
					video: true,
				})
				this.localStream.setVideoProfile({
					width: 640,
					height: 640,
					frameRate: 24,
					bitrate: 600, /* kpbs */
				})
				this.localStream
					.initialize()
					.then(() => {
						console.log("初始化本地流成功")
						// 创建好后才能播放 本地流播放 local_stream 是div的id
						this.localStream.play("local_stream");
						this.$nextTick(() => {
							// 创建好后才能发布
							this.publishStream();
						});
						this.hasLocal = true;
						this.updateStream();
					})
					.catch((error) => {
						_this.AppUtils.alert("初始化本地流失败 " + error);
						_this.hasLocal = false;
						var accidentId = _this.roomId;
						var roomId = _this.nowId;
						_this.$axios.post(`/admin/accident/${accidentId}/video/room/dismiss/${roomId}`).then((res) => {
							let data = res.data;
							if (data.code === 0) {} else {
								_this.$message.error(data.msg);
							}
						})
					})
			},
			// 发布本地音视频流
			publishStream() {
				var _this = this;
				this.client
					.publish(this.localStream)
					.catch((error) => {
						_this.AppUtils.alert("本地流发布失败 " + error);
					})
					.then(() => {
						$("#local_stream").addClass("mainVedio").parent().addClass("active");
						console.log("本地流发布成功")
					})
			},
			// 远端监听
			updateStream() {
				var that = this;
				this.client.on("peer-leave", (event) => {
					console.log("远端关闭")
					that.hasLocal = false;
					// this.$message.error("报警人已挂断，请稍候");
					const userId = event.userId;
					let ind;
					ind = that.list.findIndex((v) => v.userId === userId);

					let obj = that.list[ind];
					let element = document.getElementById(obj.id);
					let parentNode = element.parentNode.parentNode;

					if (ind == 0) {
						let element = document.getElementById(obj.id);
						element.parentNode.parentNode.removeChild(element.parentNode);
					} else if (ind > 0) {
						let element = document.getElementById(obj.id);
						element.parentNode.parentNode.removeChild(element.parentNode);
					}

					if (parentNode.children.length == 2) {
						this.$message.error('已全部挂断');
						that.leaveRoom();
					}
					if (parentNode.children.length > 2) {
						this.$message.error('有人退出');
						this.myTempIndex = 0;
					}
					//8005
					that.list.splice(ind, 1);
					that.fullVideo = false;
				})
				this.client.on("stream-removed", (event) => {
					console.log('remove了')
					const remoteStream = event.stream;
				})
				// 关闭摄像头
				this.client.on("mute-video", (evt) => {
					let streamId = this.getUidByStreamId(evt.userId);
					if (streamId) {
						$("#mask_" + streamId).show();
					}
				})
				// 打开摄像头
				this.client.on("unmute-video", (evt) => {
					let streamId = this.getUidByStreamId(evt.userId);
					if (streamId) {
						$("#mask_" + streamId).hide();
					}
				})
				// 关闭语音
				this.client.on("mute-audio", (evt) => {
					let streamId = this.getUidByStreamId(evt.userId);
					$(`${"#user_" + streamId}`).find("#audio_" + streamId).hide().next().show();
				})
				// 打开语音
				this.client.on("unmute-audio", (evt) => {
					let streamId = this.getUidByStreamId(evt.userId);
					$(`${"#user_" + streamId}`).find("#unaudio_" + streamId).hide().prev().show();
				})
			},
			// 根据id获取uid
			getUidByStreamId(streamId) {
				for (let [uid, stream] of this.members_) {
					if (stream.getUserId() == streamId) {
						return uid;
					}
				}
			},
			// 订阅远端流--加入房间之前
			subscribeStream() {
				this.showPolice = true;
				let _this = this;
				this.client.on("stream-added", (event) => {
					const remoteStream = event.stream;
					this.isHave = false;
					for (let [uid, stream] of this.members_) {
						if (stream.getUserId() === remoteStream.getUserId()) {
							$("#user_" + stream.getId()).remove();
							this.members_.delete(stream.getId());
							this.isHave = true;
						}
					}
					remoteStream.isMute = true;
					remoteStream.muteMeVideo = () => {
						remoteStream.muteVideo();
					}
					remoteStream.getAdLevel = () => {
						return remoteStream.getAudioLevel();
					}
					remoteStream.stopVideo = () => {
						remoteStream.stop();
					}
					remoteStream.on('player-state-changed', event => {
						if (event.state === 'PAUSED') {

						}
					})
					remoteStream.snapRemoteImgMore = (remoteStreams, id) => {
						return new Promise((resolve, reject) => {
							_this.$nextTick(() => {
								const frame = remoteStreams.getVideoFrame();
								if (frame) {
									resolve(frame)
								} else {
									reject('无法获得截图数据')
								}
							})
						})
					}
					remoteStream.muteMeAudio = (id, phone) => {
						let res;
						let phoneKey = 'phone_' + phone;
						setTimeout(() => {
							if (!remoteStream.isMute) {
								let classMy = `#remote_stream-${id} .unMute`;
								$(classMy).attr("class", "mute");
								//8361
								res = remoteStream.muteAudio();
								_this.$message.info('该用户话筒已关闭，其他用户已听不到声音！');
								//8849
								_this.muteMeObj[phoneKey] = true;
							} else {
								let classMy = `#remote_stream-${id} .mute`;
								$(classMy).attr("class", "unMute");
								res = remoteStream.unmuteAudio();
								_this.muteMeObj[phoneKey] = false;
							}
						}, 0)
					}

					this.members_.set(remoteStream.getId(), remoteStream);
					// 订阅远端流
					this.client.subscribe(remoteStream);
				})
			},
			snapRemoteImg(videoUserId) {
				var _this = this;
				return new Promise((resolve, reject) => {
					let remoteStream;
					let id;
					let members = this.members_;
					let values = members.values();
					values = Array.from(values);
					let findMember = values.find(value => value.userId_ == videoUserId);
					remoteStream = findMember;
					id = findMember.id_;
					let stream = _this.list[0];
					_this.$nextTick(() => {
						const frame = remoteStream.getVideoFrame();
						if (frame) {
							resolve(frame);
						} else {
							reject("无法获得截图数据");
						}
					})
				})
			},
			snapRemoteImgMore(remoteStream, id) {
				let _this = this;
				return new Promise((resolve, reject) => {
					_this.$nextTick(() => {
						remoteStream.stop();
						remoteStream.play('remote_stream-' + id).then(() => {
							const frame = remoteStream.getVideoFrame();
							if (frame) {
								resolve(frame)
							} else {
								reject('无法获得截图数据')
							}
						})
					})
				})
			},
			muteMyVideo(id) {
				let stream = this.members_.get(id);
				stream.muteMeVideo();
			},
			muteMyAudio(id, phone) {
				let stream = this.members_.get(id);
				stream.isMute = !stream.isMute;
				this.members_.get(id, stream);
				stream.muteMeAudio(id, phone);
			},
			snapMyVideo(id) {
				let stream = this.members_.get(id);
				stream.snapRemoteImgMore(stream, id).then(data => {
					console.log('snap', data)
				})
			},
			stopMyVideo(id) {
				let stream = this.members_.get(id);
				// stream.stopVideo();
				this.client.unsubscribe(stream).catch(e => {
					console.error('failed to unsubscribe remoteStream')
				})
			},
			// 播放远端流
			playStream() {
				var that = this;
				this.client.on("stream-subscribed", async (event) => {
					this.videoBtnShow = false;
					const remoteStream = event.stream;
					let isMute = remoteStream.isMute;
					this.newStream = event.stream;
					// 创建远端流标签，因为id是动态的，所以动态创建，用了v-html
					const id = remoteStream.getId();
					const userId = remoteStream.getUserId();
					this.id = id;
					let myUsers = [];
					let findRes = myUsers.find(user => user.videoUserId == userId);
					let role;
					// let phone;
					let phone = this.userInfo.phone;
					if (findRes) {
						phone = findRes.phone || findRes.driverContact;
					}
					let phoneKey = 'phone_' + phone;
					if (that.muteMeObj[phoneKey] == true || that.muteMeObj[phoneKey] == false) {
						isMute = !that.muteMeObj[phoneKey];
						remoteStream.isMute = isMute;
						if (isMute) {
							remoteStream.unmuteAudio();
						} else {
							remoteStream.muteAudio();
						}
					}

					let findMyIndex = this.list.findIndex((v) => v.userId === remoteStream.getUserId())
					if (findMyIndex == -1) {
						console.log('走这里吧1')
						console.log('1', this.list)
						let length = this.list.length;
						length += 1;
						let name;
						if (userId && userId.indexOf('a') == 0) {
							name = '120人员';
						} else {
							name = '当事人';
						}
						this.remoteStream = `<div id="${'remote_stream-' + id}" style="width:100%;height:100%;position:relative;" onClick="goTop('${userId}','${id}')">
                                <span class="leftSide" onClick="muteMyAudio('${id}','${phone}');event.cancelBubble = true;">
                                    <span class="${isMute?'unMute':'mute'}" style="cursor:pointer" ></span>
                                    <span class="role">${name}</span>
                                </span>
                                <span class="stop" style="cursor:pointer;display:none;" onClick="kickPerson('${userId}');event.cancelBubble =true;"></span>
                                <span class="phone">${phone}</span>
                            </div>`;
						this.list.push({
							id,
							userId: remoteStream.getUserId(),
							remoteStream: this.remoteStream,
							origin: remoteStream,
						})
						if (this.list.length > 1) {
							$("#local_stream").removeClass('margin0');
						}
					} else {
						console.log('2', this.list)
						console.log('走这里吧2')
						let length = findMyIndex + 1;
						let name;
						if (userId && userId.indexOf('a') == 0) {
							name = '120人员';
						} else {
							name = '当事人';
						}
						this.remoteStream = `<div id="${'remote_stream-' + id}" style="width:100%;height:100%;position:relative;" onClick="goTop('${userId}','${id}')">
                                <span class="leftSide" onClick="muteMyAudio('${id}','${phone}');event.cancelBubble =true;">
                                    <span class="${isMute?'unMute':'mute'}" style="cursor:pointer" ></span>
                                    <span class="role">${name}</span>
                                </span>
                                <span class="stop" style="cursor:pointer;display:none;" onClick="kickPerson('${userId}');event.cancelBubble =true;"></span>
                                <span class="phone">${phone}</span>
                            </div>`;
						this.list.splice(
							findMyIndex,
							1, {
								id,
								userId: remoteStream.getUserId(),
								remoteStream: this.remoteStream,
								origin: remoteStream,
							}
						)
						if (this.list.length > 1) {
							$("#local_stream").removeClass('margin0');
						}
					}
					// 做了dom操作 需要使用$nextTick(),否则找不到创建的标签无法进行播放
					this.$nextTick(() => {
						console.log('有木有')
						// 播放
						remoteStream.play("remote_stream-" + id).then(() => {

						});
						let audio = $("#audio").clone();
						audio.attr("id", "audio_" + id);
						audio.css({
							width: "14px",
							height: "21px",
							background: "none",
							"margin-left": "auto",
						});
						let unaudio = $("#unaudio").clone();
						unaudio.attr("id", "unaudio_" + id);
						unaudio.css({
							width: "14px",
							height: "21px",
							background: "none",
							"margin-left": "auto",
						});

						let mask = $("#mask").clone();
						mask.text("");
						mask.attr("id", "mask_" + id);
						mask.css({
							width: "100%",
							height: "100%",
							"text-align": "center",
							"z-index": "99",
						});
						mask.appendTo($("#player_" + id));
						mask.hide();
						$("#player_" + id).css('background', "#eee")
						$("#player_" + id).css('box-sizing', "border-box");
						$("#player_" + id).css('padding', "2px");
						let status = $("<div>", {
							id: "status_" + id,
						});
						status.css({
							width: "100%",
							height: "100%",
							"text-align": "center",
							color: "#fff",
							display: "flex",
							"align-items": "center",
							"justify-content": "center",
						});
						status.html("<span>已离开会议<span>");
						status.appendTo($("#player_" + id));
						status.hide();
						$("#player_" + id).css({
							position: "absolute",
							top: "0px"
						});
					})
				})
			},
			async closeRoom() {
				if (!this.localStream) {
					return;
				}
				console.log("关闭本地")
				this.newStream = null;
				this.videoBtnShow = true;
				await this.client.unpublish(this.localStream);
				this.localStream.stop();
				this.localStream.close();
				this.localStream = null;
				this.fullVideo = false;
				await this.client.leave();
			},
			// 获取用户签名--前端测试用
			genTestUserSig(userID) {
				const SDKAPPID = config.sdkappid;
				const EXPIRETIME = 604800;
				const SECRETKEY = config.SECRETKEY;
				if (SDKAPPID === "" || SECRETKEY === "") {
					return false;
				}
				const generator = new LibGenerateTestUserSig(
					SDKAPPID,
					SECRETKEY,
					EXPIRETIME
				)
				const userSig = generator.genTestUserSig(userID);
				return {
					sdkAppId: SDKAPPID,
					userSig: userSig,
				}
			},
			// 关闭/打开摄像头
			async muteLocalVideo() {
				if (this.isVedio) {
					this.isVedio = false;
					// this.localStream.muteVideo();
					const videoTrack = this.localStream.getVideoTrack();
					if (videoTrack) {
						await this.localStream.removeTrack(videoTrack)
						// 停止采集，关闭摄像头
						videoTrack.stop();
					}
				} else {
					this.isVedio = true;
					// this.localStream.unmuteVideo();
					const videoStream = TRTC.createStream({
						userId: this.userId,
						audio: false,
						video: true
					})
					await videoStream.initialize();
					await this.localStream.addTrack(videoStream.getVideoTrack());
				}
			},
			// 关闭/打开麦克风
			async muteLocalAudio() {
				if (this.isAudio) {
					this.isAudio = false;
					this.localStream.muteAudio();
					this.$message.info('该用户话筒已关闭，其他用户已听不到声音！');
					// const audioTrack = this.localStream.getAudioTrack();
					// if (audioTrack) {
					//     audioTrack.stop();
					// }
				} else {
					this.isAudio = true;
					let res = this.localStream.unmuteAudio();
					console.log("unmuteAudio", res)
					// await this.localStream.replaceTrack(this.localStream.getAudioTrack());
				}
			},
			leaveRoom() {
				this.videoBtnShow = true;
				this.showPolice = false;
				this.remoteStatus == 'danger';
				this.list = [];
				this.muteMeObj = {};
				this.hasLocal = false;
				this.closeRoom();
			},

			// *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-* 音视频相关操作 end *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*

		},
	}
</script>

<style lang="less" scoped>
	.main {
		display: flex;
		background: #fff;
		flex-direction: row;
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		overflow-y: hidden;
		z-index: 100;
		flex-direction: column;
		box-sizing: border-box;
		padding-top: 3px;
		padding-left: 10px;
	}

	.leftContent {
		overflow-x: hidden;
		height: calc(100% - 50px);
		overflow-y: scroll;
		box-sizing: border-box;
		text-align: left;
		margin-right: 10px;
		float: left;

		.tableContent {
			margin-top: 10px;
			border: 1px solid #f4f5f7;
			flex: 3;
		}
	}

	.rightContent {
		width: 471px;
		// height: 100%;
		height: calc(100% - 90px);
		display: flex;
		position: fixed;
		top: 53px;
		right: 2px;
		float: right;

		.left {
			width: 100%;
			box-sizing: border-box;
			display: flex;
			overflow-y: auto;
			background: #eee;
			align-content: flex-start;
			margin-bottom: 10px;
			flex-wrap: nowrap;
			flex-direction: column;

			.userlist {
				width: 190px;
				height: 150px;
				border-radius: 1px;
				margin-top: 10px;
				position: static;
				display: flex;
				flex-direction: column;
				margin-top: auto;
				background-position: center 0px;
				background-size: 100%;
				position: relative;
				margin-left: 0px;

				&:nth-child(2n) {
					margin-left: 0px;
				}

				p {
					color: #fff;
					font-size: 14px;
					text-align: center;
				}

				.img {
					width: 100%;
					height: 130px;
					background: #fff;
				}
			}

			.remoteClass {
				width: 100%;
				height: 122px;
				margin-top: 0px !important;
				border: none !important;
			}

			.fullRemoteClass {
				width: 100% !important;
				margin-top: 25px;
				border: none !important;
			}
		}

		.right {
			width: calc(100vw - 210px);
			height: calc(100vh - 69px);
			background-color: #3d3b3b;
			border-radius: 1px;
			margin: 0 10px 10px 10px;
			padding: 0 10px;

			.container {
				width: 100%;
				height: 820px;
				background: #191f24;
			}

			.maskshow {
				display: block;
			}

			.operator {
				display: flex;
				justify-content: center;
				margin-top: 20px;
				text-align: center;
				position: absolute;
				bottom: 40px;
				left: 50%;

				.item {
					display: flex;
					flex-direction: column;
					width: 80px;

					&:nth-child(1) .img-warp .img {
						width: 23px;
					}

					&:nth-child(2) .img-warp .img {
						width: 40px;
					}

					&:nth-child(3) .img-warp {
						background: #e63517;

						.img {
							width: 44px;
						}
					}

					.img-warp {
						width: 100%;
						height: 45px;
						text-align: center;
						line-height: 45px;
						background: #e3e3e3;
						border-radius: 10px;
						position: relative;

						.img {
							position: absolute;
							left: 50%;
							top: 50%;
							transform: translate(-50%, -50%);
						}
					}

					&:not(:first-child) {
						margin-left: 20px;
					}

					.item-icon {
						width: 80px;
						height: 45px;
						line-height: 45px;
						background-color: #e3e3e3;
						border-radius: 10px;
					}

					span {
						font-size: 16px;
						text-align: center;
						color: #fff;
						margin-top: 10px;
					}
				}
			}
		}
	}

	.distant-stream {
		width: 100%;
		height: 100%;
	}

	#local_stream {
		width: 100%;
		height: 100%;
	}

	.mainVedio {
		position: absolute;
		z-index: 110;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		padding-left: 2px;
		padding-right: 2px;
		padding-bottom: 2px;
	}

	#warp {
		display: flex;
		flex-direction: column;
	}

	.maskable {
		position: absolute;
		width: calc(100% - 386px);
		right: 0px;
		height: 80%;
		color: #fff;
		text-align: center;
		line-height: 900px;
		background: url(../../../static/images/08摄像头已关闭@2x.png) center no-repeat;
	}

	.wholeAcccindentClass {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		flex-wrap: wrap;

		.accidentImages {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			flex-flow: wrap;

			.images {
				display: flex;
				align-items: center;
				justify-content: flex-start;
				flex-direction: column;
				height: 200px;
				margin: 10px;

				.img-box {
					width: 200px;
					margin: 0 auto;
				}
			}
		}
	}

	.bottomBtns {
		width: 100%;
		position: fixed;
		left: 0px;
		bottom: 0px;
		background: #ccc;
		margin-bottom: 0px;
		height: 48px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.hang_up_btn {
		width: 40px;
		height: 40px;
		margin-left: 150px;
	}
	.hang_up_btn img {
		width: 100%;
		height: 100%;
	}

	.original_left {
		width: calc(100% - 473px);
	}

	.fullVideoClass_left {
		width: calc(100% - 610px) !important;
	}

	.fullVideoClass_right {
		max-width: 600px !important;
		min-width: 600px !important;
	}

	.myBtn {
		padding: 12px 16px !important;
		color: #000;
		cursor: pointer;

		img {
			width: 50px;
			height: 50px;
			margin-bottom: 10px
		}
	}

	.myMainVideo {
		width: 100% !important;
		height: 476px !important;
		margin: 0 auto !important;
		position: absolute !important;
		top: 2px;
		left: 50%;
		margin-left: -50% !important;
	}

	.myIcon {
		width: 28px;
		height: 28px;
		position: absolute;
		right: 3px;
		top: 3px;
		z-index: 99999;
		cursor: pointer;
	}

	.fullVideoClass_right {
		height: 88%;
		overflow: scroll;
	}

	.fullVideoClass_right .left .user,
	.fullVideoClass_right .left .police {
		height: 200px !important;
		width: 200px !important;
	}

	.fullVideoClass_right .myMainVideo {
		height: 600px !important;
	}

	.close_img {
		width: 14px;
		height: 14px;
		margin-left: 7px;
	}

	.jumpBtn {
		position: absolute;
		right: 476px;
		height: 30px;
		display: flex;

		.myJumpBtn {
			box-sizing: border-box;
			padding: 0px 5px;
			font-size: 12px;
			border: 1px solid #409eff;
			border-radius: 4px;
			margin-right: 10px;
			line-height: 28px;
			background: #409eff;
			color: #fff;
			cursor: pointer;
		}
	}

	.crumb {
		margin: 6px;

		.crumb_item {
			box-sizing: border-box;
			cursor: pointer;
			padding: 5px 10px !important;
		}
	}

	.activeCrumb {
		color: #1728d5;
		font-weight: bold;
	}

	.main /deep/ input::-webkit-outer-spin-button,
	.main /deep/ input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	// .main /deep/ input[type="number"] {
	//     -moz-appearance: textfield;
	// }

	.big_case {
		width: 96%;
		margin: 0 auto;
		display: flex;
		border-bottom: 1px solid #ededed
	}

	.ul_case {
		width: 80%;
		margin: 0px auto;
		padding: 10px;
	}

	.ul_case li {
		display: flex;
		margin: 5px 0;
	}

	.ul_contor {
		width: 10%;
		padding: 10px;
	}

	.ul_contor li {
		height: 30px;
		// margin: 10px 0;
		display: flex;
		// align-items: center;
		// justify-content: center;
	}

	.ul_contor li i {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 23px;
		color: #409EFF;
		cursor: pointer;
	}

	.big_case .ul_contor .ul_li_btn {
		width: 100px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		display: block;
		background: #409EFF;
		color: #fff;
		cursor: pointer;
	}

	.retrun_case {
		display: flex;
		flex-flow: wrap;
	}

	.retrun_image {
		width: 200px;
		height: 200px;
		margin: 10px 5px;
		display: block;
		cursor: pointer;
	}

	.rotate_image {
		transform: rotate(0deg);
	}

	.my_input /deep/ .el-textarea__inner {
		font-size: 16px;
		font-weight: bold;
		color: #000;
	}
	.no_video_text {
		justify-content: center;
		align-items: center;
		font-size: 16px;
		font-weight: 600;
		color: #F56C6C;
	}
</style>


// WEBPACK FOOTER //
// videoEasy.vue?0052ae8e